module.exports = __webpack_public_path__ + "static/loyalty-tiers-14dc17d63237622511d5cd7b12b2878d.png";